'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'marker';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5a1';
var svgPathData = 'M358.5 52.9L201 210.3 301.7 311 459.1 153.5c13.4-13.4 20.9-31.5 20.9-50.3 0-39.3-31.9-71.2-71.2-71.2-18.9 0-37 7.5-50.3 20.9zM178.3 233L125 286.3C79.7 331.6 49.5 389.7 38.3 452.7l-4.5 25.4 25.4-4.5c63-11.1 121.1-41.4 166.4-86.6L279 333.7 178.3 233zM335.8 30.2c19.4-19.4 45.6-30.2 73-30.2 57 0 103.2 46.2 103.2 103.2 0 27.4-10.9 53.6-30.2 73L248.3 409.7c-49.9 49.9-114 83.3-183.5 95.5l-36.7 6.5C20.5 513 12.6 510.5 7 505s-8-13.4-6.7-21.1l6.5-36.7c12.3-69.5 45.6-133.6 95.5-183.5L299.7 66.3 278.6 45.3c-12.5-12.5-32.8-12.5-45.3 0L123.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L210.7 22.6c25-25 65.5-25 90.5 0l21.1 21.1 13.5-13.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMarker = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;